module.exports = __webpack_public_path__ + "static/media/share.79a6b570.svg";